var _svg;
import React from "react";
const Lock = ({
  ...rest
}) => {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    width: "42",
    height: "42",
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 17V13.3333C31.6666 8.27073 27.5625 4.16666 22.4999 4.16666C17.4373 4.16666 13.3333 8.27073 13.3333 13.3333V17C10.297 17.0033 7.83661 19.4638 7.83325 22.5V35.3333C7.83661 38.3696 10.297 40.83 13.3333 40.8333H31.6666C34.7028 40.83 37.1632 38.3696 37.1666 35.3333V22.5C37.1632 19.4638 34.7028 17.0033 31.6666 17ZM15.1666 13.3333C15.1666 9.28318 18.4498 5.99999 22.4999 5.99999C26.5501 5.99999 29.8333 9.28318 29.8333 13.3333V17H15.1666V13.3333ZM35.3333 35.3333C35.3307 37.3573 33.6906 38.9974 31.6666 39H13.3333C11.3092 38.9974 9.66916 37.3573 9.66659 35.3333V22.5C9.66916 20.476 11.3092 18.8359 13.3333 18.8333H31.6666C33.6906 18.8359 35.3307 20.476 35.3333 22.5V35.3333ZM22.4999 24.3333C21.9937 24.3333 21.5833 24.7438 21.5833 25.25V32.5843C21.5836 33.0903 21.9939 33.5003 22.4999 33.5H22.501C23.0069 33.4997 23.4169 33.0893 23.4166 32.5833V25.25C23.4166 24.7438 23.0061 24.3333 22.4999 24.3333Z",
    fill: "#AD0026"
  })));
};
export default Lock;